module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/pop-02010d68c5d18610e233b781275f58dc.png";